import {Customer, CustomerConst, DataCustomersArray, FilterCustomer} from '@/models/Customer'
import {Item} from '@/models/Item'
import {DataOrder, DataOrdersArray, FilterOrder, Order, OrderConst} from '@/models/Order'
import {DataProductsArray, FilterProduct} from '@/models/Product'
import {DataPromotionsArray, FilterPromotion} from '@/models/Promotion'
import {DataShippingsArray, FilterShipping} from '@/models/Shipping'
import {DataUsersArray, FilterUser} from '@/models/User'
import {Promotion} from '@/models/Promotion'
import {gVariable} from '@/services/globalData'
import Vue from 'vue'
import Vuex from 'vuex'

import Helper from '../services/Helper.js'

Vue.use(Vuex)

import app from '../main'

export default new Vuex.Store({
  state: {
    $user: {
      id: 0,
      nickname: '',
      name: '',
      role: 20,
      department: '',
      employee_code: '',
      theme: 0,
      picture: null,
      signature: null,
      unread_notifications: 0
    },
    intended: null,
    need_register_line: false,
    dialog_line: false,
    dialog: {
      customer: false,
      order: false,
      product: false,
      item: false,
      item_point: false,
      sales: false
    },
    customers: {
      response: new DataCustomersArray(),
      data: new DataCustomersArray().data,
      filter: new FilterCustomer(),
      current: 0,
      scrollY: 0,
      sort: 'code',
      display: 'list',
      default_value: {
        type: '',
        business_type: '',
        district: '',
        province: '',
        zip_code: '',
        credit_amount: 3000,
        credit_term: 30
      }
    },
    products: {
      response: new DataProductsArray(),
      data: new DataProductsArray().data,
      filter: new FilterProduct(),
      current: 0,
      scrollY: 0,
      sort: 'code',
      display: 'list'
    },
    dynamicPromotions: {
      response: new DataPromotionsArray(),
      data: new DataPromotionsArray().data,
      expire_at: 0
    },
    promotions: {
      response: new DataPromotionsArray(),
      data: new DataPromotionsArray().data,
      filter: new FilterPromotion(),
      current: 0,
      scrollY: 0,
      sort: 'id',
      display: 'list'
    },
    orders: {
      response: new DataOrdersArray(),
      data: new DataOrdersArray().data,
      filter: new FilterOrder(),
      summary: {},
      current: 0,
      scrollY: 0,
      sort: 'erp_so_at',
      display: 'list',
      dateFrom: '1970-01-01',
      dateTo: '1970-01-01'
    },
    shipping: {
      response: new DataShippingsArray(),
      data: new DataShippingsArray().data,
      filter: new FilterShipping(),
      summary: {},
      current: 0,
      scrollY: 0,
      sort: 'status',
      display: 'list',
      dateFrom: '1970-01-01',
      dateTo: '1970-01-01'
    },
    orders_pending: {
      response: new DataOrdersArray(),
      data: new DataOrdersArray().data,
      filter: new FilterOrder(),
      summary: {},
      pending: true,
      current: 0,
      scrollY: 0,
      sort: 'status',
      display: 'list',
      dateFrom: '1970-01-01',
      dateTo: '1970-01-01'
    },
    users: {
      response: new DataUsersArray(),
      data: new DataUsersArray().data,
      filter: new FilterUser(),
      id_map: {},
      code_map: {},
      current: 0,
      scrollY: 0
    },
    carts: {
      response: new DataOrdersArray(),
      data: new DataOrdersArray().data,
      current: new Order(),
      current_index: 0,
      scrollY: 0,
      current_item_map: {},
      current_promotion_map: {},
      current_customer_map: {}
    },
    items: {
      current_index: 0
    },
    config: {
      business_type_price: {}
    }

  },
  mutations: {
    current_user(state, user) {
      state.$user = user
    },
    notification_delta(state, delta) {
      state.$user.unread_notifications += delta
    },
    dialog_is_customer(state, {toggle, index}) {
      state.dialog.customer = toggle
      if (index >= 0) {
        state.customers.current = index
      }
    },
    dialog_is_order(state, {toggle, index, id}) {
      state.dialog.order = toggle
      if (index >= 0) {
        state.orders.current = index
      }
    },
    dialog_is_product(state, {toggle, index}) {
      state.dialog.product = toggle
      if (index >= 0) {
        state.products.current = index
      }
    },
    dialog_is_item(state, {toggle, index}) {
      state.dialog.item = toggle
      if (index >= 0) {
        state.items.current_index = index
      }
    },
    dialog_is_item_point(state, {toggle, index}) {
      state.dialog.item_point = toggle
      if (index >= 0) {
        state.items.current_index = index
      }
    },
    dialog_is_sales(state, {toggle, index}) {
      state.dialog.sales = toggle
    },

    customers_scrollY(state, y) {
      state.customers.scrollY = y
    },
    products_scrollY(state, y) {
      state.products.scrollY = y
    },
    promotions_scrollY(state, y) {
      state.promotions.scrollY = y
    },
    orders_scrollY(state, y) {
      state.orders.scrollY = y
    },
    order_pending_scrollY(state, y) {
      state.orders.scrollY = y
    },

    shipping_scrollY(state, y) {
      state.shipping.scrollY = y
    },
    customers_pageOption(state, {y, sort, display}) {
      state.customers.scrollY = y
      state.customers.sort = sort
      state.customers.display = display
    },
    products_pageOption(state, {y, sort, display}) {
      state.products.scrollY = y
      state.products.sort = sort
      state.products.display = display
    },
    promotions_pageOption(state, {y, sort, display}) {
      state.promotions.scrollY = y
      state.promotions.sort = sort
      state.promotions.display = display
    },
    orders_pageOption(state, {y, sort, display}) {
      state.orders.scrollY = y
      state.orders.sort = sort
      state.orders.display = display
    },

    orders_pending_pageOption(state, {y, sort, display}) {
      state.orders_pending.scrollY = y
      state.orders_pending.sort = sort
      state.orders_pending.display = display
    },

    shipping_pageOption(state, {y, sort, display}) {
      state.shipping.scrollY = y
      state.shipping.sort = sort
      state.shipping.display = display
    },


    customer_current(state, delta) {
      state.customers.current = (state.customers.current + delta) % state.customers.response.data.length
      if (state.customers.current < 0)
        state.customers.current += state.customers.response.data.length
    },
    customers_response(state, response) {
      state.customers.response = response
      state.customers.data = state.customers.response.data
      state.customers.filter = state.customers.response.filter
      state.customers.current = 0
    },
    customers_append(state, response: DataCustomersArray) {
      state.customers.response.links.next = response.links.next
      state.customers.response.data.push(...response.data)
      state.customers.current = 0
      // debugger
    },
    update_default_customer(state, customer: Customer) {
      customer.type && (state.customers.default_value.type = customer.type)
      customer.business_type && (state.customers.default_value.business_type = customer.business_type)
      customer.credit_amount && (state.customers.default_value.credit_amount = customer.credit_amount)
      customer.credit_term && (state.customers.default_value.credit_term = customer.credit_term)
      customer.district && (state.customers.default_value.district = customer.district)
      customer.province && (state.customers.default_value.province = customer.province)
      customer.zip_code && (state.customers.default_value.zip_code = customer.zip_code)


    },


    product_current(state, delta) {
      state.products.current = (state.products.current + delta) % state.products.response.data.length
      if (state.products.current < 0)
        state.products.current += state.products.response.data.length
    },
    products_response(state, response) {
      state.products.response = response
      state.products.data = state.products.response.data
      state.products.filter = state.products.response.filter
      state.products.current = 0
    },
    products_append(state, response: DataProductsArray) {
      state.products.response.links.next = response.links.next
      state.products.response.data.push(...response.data)
      state.products.current = 0
      // debugger
    },

    promotion_current(state, delta) {
      state.promotions.current = (state.promotions.current + delta) % state.promotions.response.data.length
      if (state.promotions.current < 0)
        state.promotions.current += state.promotions.response.data.length
    },
    dynamicPromotions_response(state, response) {
      state.dynamicPromotions.response = response
      state.dynamicPromotions.data = state.dynamicPromotions.response.data
      state.dynamicPromotions.expire_at = Date.now() + 1000 * 60 * 60 // 60 == 1 hr
      console.log('next expire', state.dynamicPromotions.expire_at)
    },
    promotions_response(state, response) {
      state.promotions.response = response
      state.promotions.data = state.promotions.response.data
      state.promotions.filter = state.promotions.response.filter
      state.promotions.current = 0
    },
    promotions_append(state, response: DataPromotionsArray) {
      state.promotions.response.links.next = response.links.next
      state.promotions.response.data.push(...response.data)
      state.promotions.current = 0
      // debugger
    },

    order_current(state, delta) {
      state.orders.current = (state.orders.current + delta) % state.orders.response.data.length
      if (state.orders.current < 0)
        state.orders.current += state.orders.response.data.length
    },
    orders_response(state, response) {
      state.orders.response = response
      state.orders.data = state.orders.response.data
      state.orders.filter = state.orders.response.filter
      state.orders.summary = state.orders.response.summary
      state.orders.current = 0
    },
    orders_append(state, response: DataOrdersArray) {
      state.orders.response.links.next = response.links.next
      state.orders.response.data.push(...response.data)
      state.orders.current = 0
      // debugger
    },
    orders_update(state, {index, order}) {
      // debugger
      state.orders.response.data[index] = order

      // debugger
    },

    orders_pending_response(state, response) {
      state.orders_pending.response = response
      state.orders_pending.data = state.orders_pending.response.data
      state.orders_pending.filter = state.orders_pending.response.filter
      state.orders_pending.summary = state.orders_pending.response.summary
      state.orders_pending.current = 0
    },
    orders_pending_append(state, response: DataOrdersArray) {
      state.orders_pending.response.links.next = response.links.next
      state.orders_pending.response.data.push(...response.data)
      state.orders_pending.current = 0
      // debugger
    },
    orders_pending_update(state, {index, order}) {
      state.orders_pending.response.data[index] = order
    },


    shipping_current(state, delta) {
      state.shipping.current = (state.shipping.current + delta) % state.shipping.response.data.length
      if (state.shipping.current < 0)
        state.shipping.current += state.shipping.response.data.length
    },

    shipping_response(state, response) {
      state.shipping.response = response
      state.shipping.data = state.shipping.response.data
      state.shipping.filter = state.shipping.response.filter
      state.shipping.summary = state.shipping.response.summary
      state.shipping.current = 0
    },
    shipping_append(state, response: DataShippingsArray) {
      state.shipping.response.links.next = response.links.next
      state.shipping.response.data.push(...response.data)
      state.shipping.current = 0
      // debugger
    },
    shipping_update(state, {index, shipping}) {
      // debugger
      state.shipping.response.data[index] = shipping

      // debugger
    },


    users_response(state, response) {
      state.users.response = response
      state.users.data = state.users.response.data
      state.users.filter = state.users.response.filter

      state.users.id_map = {}
      state.users.code_map = {}
      for (let i = 0; i < state.users.data.length; i++) {
        let user = state.users.data[i]
        if (user.id)
          state.users.id_map[user.id] = user
        if (user.employee_code)
          state.users.code_map[user.employee_code] = user
      }
    },


    carts_response(state, response: DataOrdersArray) {

      for (let i = 0; i < response.data.length; i++) {
        response.data[i].dynamicPromotionItems = response.data[i].items.filter(item =>
          item.promotion_type == 'F'
        )
        response.data[i].items = response.data[i].items.filter(item =>
          item.promotion_type != 'F'
        )
        response.data[i].items.map(item => {
          if (item.promotion && item.promotion.promotion_type == 'D') {
            item.promotion = null
            item.promotion_id = null
            item.promotion_qty = null
            item.is_start_of_promotion = null
          }
          return item
        })
      }
      // debugger


      state.carts.response = response
      state.carts.data = state.carts.response.data
      state.carts.current_index = 0
      if (state.carts.data.length > 0) {
        const cart = state.carts.current = state.carts.data[state.carts.current_index]
        const {item_map, promotion_map} = Order.cart_validate(cart, state.dynamicPromotions.data)
        state.carts.current_item_map = item_map
        state.carts.current_promotion_map = promotion_map

        state.carts.current_customer_map = {}
        for (let i = 0; i < state.carts.data.length; i++) {
          let cart = state.carts.data[i]
          state.carts.current_customer_map[cart.customer_id] = cart
        }
      }
      //debugger
    },
    carts_index(state, index) {
      state.carts.current_index = index
      const cart = state.carts.current = state.carts.data[state.carts.current_index]
      const {item_map, promotion_map} = Order.cart_validate(cart, state.dynamicPromotions.data)
      state.carts.current_item_map = item_map
      state.carts.current_promotion_map = promotion_map
    },
    carts_append(state, cart: Order) {
      state.carts.response.data.push(cart)
      cart = state.carts.current = state.carts.response.data[state.carts.response.data.length - 1]
      const {item_map, promotion_map} = Order.cart_validate(cart, state.dynamicPromotions.data)
      state.carts.current_item_map = item_map
      state.carts.current_promotion_map = promotion_map
      state.carts.current_customer_map[cart.customer_id] = cart
      state.carts.current_index = state.carts.response.data.length - 1
    },
    async set_cart_prop(state, obj: Order) {
      const cart = state.carts.current = state.carts.data[state.carts.current_index]
      Object.assign(cart, obj)
      const {item_map, promotion_map} = Order.cart_validate(cart, state.dynamicPromotions.data)
      state.carts.current_item_map = item_map
      state.carts.current_promotion_map = promotion_map
    },

    carts_remove(state, remove_cart: Order) {
      const orders = state.carts.response.data
      let found_cart = -1
      for (let i = 0; i < orders.length; i++) {
        if (remove_cart.customer_id == orders[i].customer_id) {
          found_cart = i
          break
        }
      }

      if (found_cart > -1) {
        state.carts.response.data.splice(found_cart, 1)
        // debugger;
        if (state.carts.response.data.length > 0) {
          state.carts.current_index = state.carts.response.data.length - 1
          const cart = state.carts.current = state.carts.response.data[state.carts.current_index]
          const {item_map, promotion_map} = Order.cart_validate(cart, state.dynamicPromotions.data)
          state.carts.current_item_map = item_map
          state.carts.current_promotion_map = promotion_map
        } else {
          state.carts.current = new Order()
          state.carts.current_index = 0
          state.carts.current_item_map = {}
          state.carts.current_promotion_map = {}
          state.carts.current_customer_map = {}
        }
        delete state.carts.current_customer_map[remove_cart.customer_id]
      }
    },
    item_current(state, delta) {
      state.items.current_index = (state.items.current_index + delta) % state.carts.current.items.length
    },
    config(state, data) {
      state.config = data
    }
  },
  actions: {
    //customer_current(context, delta) {
    //context.commit('customer_current', delta)
    /// let customer: Customer = context.state.customers.data[context.state.customers.current]
    //console.log(customer)
    //},

    async load_dynamicPromotions({state, commit}) {
      const url = Helper.setting.promotion.getListAPI + '?type=D&per_page=999'
      const timeNow = Date.now()
      if (timeNow > state.dynamicPromotions.expire_at || !state.dynamicPromotions.data || state.dynamicPromotions.data.length == 0) {
        console.log('now', timeNow)
        console.log('expire', state.dynamicPromotions.expire_at)

        try {
          let data: DataPromotionsArray = await Helper.get(url)
            .then<{ data: DataPromotionsArray }>(({data}) => data)

          commit('dynamicPromotions_response', data)
        } catch (e) {
          alert(e)
        }
        return state.dynamicPromotions.data
      }
    },

    async load_carts({state, commit}): Promise<Order[]> {
      gVariable.tabs.carts.isLoad = true

      if (!state.carts.data || state.carts.data.length == 0) {

        let data: DataOrdersArray = await Helper.get(Helper.setting.carts.getListAPI)
          .then<{ data: DataOrdersArray }>(({data}) => data)

        commit('carts_response', data)
      }
      gVariable.tabs.carts.isLoad = false
      return state.carts.data

    },
    async init_cart(context, customer: Customer): Promise<Order | Error> {
      // console.log(gPromise.promise_create_cart)
      // if (gPromise.promise_create_cart) return gPromise.promise_create_cart

      // return gPromise.promise_create_cart = new Promise((resolve, reject) => {

      const orders: Order[] = await context.dispatch('load_carts')

      //Search card
      let found_cart = -1
      for (let i = 0; i < orders.length; i++) {
        if (customer.id == orders[i].customer_id) {
          found_cart = i
          break
        }
      }
      let cart: Order = new Order()
      if (found_cart > -1) {
        //Found
        context.commit('carts_index', found_cart)
        cart = context.state.carts.current
      } else {
        cart.customer = customer
        cart.credit_term = customer.credit_term
        cart.customer_id = customer.id
        cart.customer_code = customer.code
        cart.stock_wh = customer.type == 'MT' ? 'MT' : 'PJ'
        cart.price_group = customer.price_group ? customer.price_group.price_group : 1
        cart.vat_type = customer.vat_type
        // cart.vat_type = OrderConst.VAT_TYPE_INCLUDE
        cart.vat_percent = 7
        cart.project_cb3 = true

        const someDate = new Date()
        const dayOfWeek = someDate.getDay()

        let t_deliver = 7
        if (customer.province_id && [50, 51].includes(customer.province_id)) {
          t_deliver = 3
        }

        if (t_deliver == 3 && (dayOfWeek >= 4 || dayOfWeek == 0)) {
          t_deliver += 1
        }
        if (t_deliver == 7) {
          // t_deliver += 1
        }


        someDate.setDate(someDate.getDate() + t_deliver) //number  of days to add, e.x. 15 days
        cart.date_delivery = someDate

        try {
          cart = await Helper.post(Helper.setting.carts.getListAPI, cart)
            .then<{ data: DataOrder }>(({data}): Order => data.data)
        } catch (e: any) {
          return e
          // this.$root.$emit('onError', {message: e.toString(), error: e})
        }

        cart.dynamicPromotionItems = cart.items.filter(item =>
          item.promotion_type == 'F'
        )
        cart.items = cart.items.filter(item =>
          item.promotion_type != 'F'
        )
        cart.items.map(item => {
          if (item.promotion && item.promotion.promotion_type == 'D') {
            item.promotion = null
            item.promotion_id = null
            item.promotion_qty = null
            item.is_start_of_promotion = null
          }
          return item
        })

        context.commit('carts_append', cart)
      }


      return cart

    },

    async commit_item(context, obj: Item) {

    },
    async set_promotion(context, {index, productPromotion}) {
      console.log(productPromotion)
      let order: Order = context.state.carts.current
      let dynamicItem = order.dynamicPromotionItems[index]

      dynamicItem.product_id = productPromotion.product_id
      dynamicItem.product = productPromotion.product
      dynamicItem.quantity = productPromotion.quantity
      dynamicItem.total_net = productPromotion.display_price * productPromotion.quantity

      order.dynamicPromotionItems[index] = dynamicItem

      console.log('Before commit', order.dynamicPromotionItems[0].product?.name)
      context.commit('carts_index', context.state.carts.current_index)
      console.log('After commit', order.dynamicPromotionItems[0].product?.name)

    },
    async set_item(context, item: Item) {
      let order: Order = context.state.carts.current
      if (order == null || order.id === null) {
        console.log('order null')
        return false
      }
      if (order.items == null) {
        console.log('items null')
        return false
      }
      // if (obj.product == null) {
      //   console.log('product null')
      //   return false
      // }
      // const product: Product = obj.product

      // let item: Item = new Item()
      // if (context.state.carts.current_item_map.hasOwnProperty(product.id)) {
      //   item = context.state.carts.current_item_map[product.id]
      // } else {
      //   console.log('items null')
      //   return false
      // }
      // Object.assign(item, obj)

      if (!item.hasOwnProperty('dirty')) {
        Object.setPrototypeOf(item, Item.prototype)
      }

      console.log('set item dirty')
      item.dirty()
      await item.gracefulSave<Item>()
      // item.undirty()

      context.commit('carts_index', context.state.carts.current_index)

    },
    async add_item_to_cart(context, {
      product,
      delta = 1,
      is_free = false,
      promotion = null,
      product_promotion = null,
      index = null
    }) {
      let order: Order = context.state.carts.current
      if (order == null || order.id === null) {
        debugger
        return false
      }
      if (order.items == null) {
        order.items = []
      }

      const vat_percent = order.vat_percent ? order.vat_percent : 0

      let is_new = false
      let item: Item = new Item()

      is_new = true
      item.index_no = order.items.length + 1
      item.order_id = order.id
      item.product_code = product.code
      item.product_id = product.id
      item.product = product
      item.unit = product.unit_primitive

      let batch_size = 1
      if (promotion) {
        item.promotion = promotion
        item.promotion_id = promotion.id
        item.promotion_qty = product_promotion.quantity
        batch_size = product_promotion.quantity
      }

      item.price_init = product.price_retail ? product.price_retail : 0

      if (product.hasOwnProperty('price_' + order.price_group)
        && product['price_' + order.price_group] > 0) {
        item.price_init = product['price_' + order.price_group]
      }

      if (is_free) {
        item.price_init = 0
      }

      item.price_in_vat = item.price_init
      item.price_ex_vat = Math.round(item.price_in_vat / (1.00 + vat_percent / 100) * 100) / 100


      item.unit = product.unit_primitive


      item.quantity = delta * batch_size

      let price_at_bill = item.price_in_vat
      item.price_final = item.price_in_vat

      if (item.discount_internal_amount !== null && item.quantity !== null) {
        price_at_bill -= item.discount_internal_amount / item.quantity
        item.price_final -= item.discount_internal_amount / item.quantity
      }

      if (item.discount_external_amount !== null && item.quantity !== null) {
        item.price_final -= (item.discount_external_amount / item.quantity) * (1.00 + vat_percent / 100)
      }
      item.price_final = Math.round(item.price_final * 100) / 100

      if (item.quantity !== null) {
        item.total_net = item.quantity * price_at_bill
        item.total_gross = Math.round(item.total_net / (1.00 + vat_percent / 100) * 100) / 100

        item.total_point = item.quantity * (item.point_final || 0)
      }

      if (!item.hasOwnProperty('dirty')) {
        Object.setPrototypeOf(item, Item.prototype)
      }
      item.dirty()
      try {
        const obj: Item = await item.gracefulSave<Item>()
        if (obj.quantity == null || obj.quantity <= 0) {
          order.items = order.items.filter(item => item.id != obj.id)
          // context.commit('carts_index', context.state.carts.current_index)
        }
      } catch (e) {
        return e
      }

      item.undirty()

      console.log(order)

      if (is_new) {

        order.items.push(item)
      }

      Order.cart_validate(order, context.state.dynamicPromotions.data)
      context.commit('carts_index', context.state.carts.current_index)
      return order
    },
    async alter_item_to_cart(context, {
      product,
      delta = 1,
      promotion = null,
      product_promotion = null,
      index = null
    }) {
      let order: Order = context.state.carts.current
      let promo: Promotion = promotion
      if (order == null || order.id === null) {
        debugger
        return false
      }
      if (order.items == null) {
        order.items = []
      }


      const vat_percent = order.vat_percent ? order.vat_percent : 0

      let is_new = false
      let item: Item = new Item()
      if (promotion && context.state.carts.current_promotion_map.hasOwnProperty(promotion.id)
        && context.state.carts.current_promotion_map[promotion.id][index]
      ) {
        item = context.state.carts.current_promotion_map[promotion.id][index]
      } else if (!promotion && context.state.carts.current_item_map.hasOwnProperty(product.id)) {
        item = context.state.carts.current_item_map[product.id]
      } else {
        is_new = true
        item.index_no = order.items.length + 1
        item.order_id = order.id
        item.product_code = product.code
        item.product_id = product.id
        item.product = product

        item.price_init = product.price_retail ? product.price_retail : 0

        if (product.hasOwnProperty('price_' + order.price_group)
          && product['price_' + order.price_group] > 0) {
          item.price_init = product['price_' + order.price_group]
        }


        item.price_in_vat = item.price_init
        item.price_ex_vat = Math.round(item.price_in_vat / (1.00 + vat_percent / 100) * 100) / 100

        item.unit = product.unit_primitive
      }


      let batch_size = 1
      if (promotion && promo.promotion_type === 'S') {
        item.promotion = promotion
        item.promotion_id = promotion.id
        item.promotion_qty = product_promotion.quantity
        batch_size = product_promotion.quantity
      }

      if (item.quantity)
        item.quantity += delta * batch_size
      else
        item.quantity = delta * batch_size

      let price_at_bill = item.price_in_vat
      item.price_final = item.price_in_vat

      if (item.discount_internal_amount !== null && item.quantity !== null) {
        price_at_bill -= item.discount_internal_amount / item.quantity
        item.price_final -= item.discount_internal_amount / item.quantity
      }

      if (item.discount_external_amount !== null && item.quantity !== null) {
        item.price_final -= (item.discount_external_amount / item.quantity) * (1.00 + vat_percent / 100)
      }
      item.price_final = Math.round(item.price_final * 100) / 100

      // console.log('item.price_final', item.price_final)

      if (item.quantity !== null) {
        item.total_net = item.quantity * price_at_bill
        item.total_gross = Math.round(item.total_net / (1.00 + vat_percent / 100) * 100) / 100
      }

      if (!item.hasOwnProperty('dirty')) {
        Object.setPrototypeOf(item, Item.prototype)
      }
      item.dirty()
      try {
        const obj: Item = await item.gracefulSave<Item>()
        if (obj.quantity == null || obj.quantity <= 0) {
          order.items = order.items.filter(item => item.id != obj.id)
          // context.commit('carts_index', context.state.carts.current_index)
        }
      } catch (e) {
        return e
      }
      item.undirty()

      console.log(order)

      if (is_new) {

        order.items.push(item)
      }
      Order.cart_validate(order, context.state.dynamicPromotions.data)
      context.commit('carts_index', context.state.carts.current_index)
      return order
    }
  },
  modules: {}
})

